
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { mdiChevronDown } from '@mdi/js';
import { VuetifyMixin } from '../../../mixins/VuetifyMixin';
import { FormRulesMixin } from '../../../mixins/FormRulesMixin';
import { DepthChartTemplatesMixin } from '../../../mixins/SelectorMixins';
import { DepthChartModel } from '../../../models/depthChart';

@Component
export default class NewDepthChartForm extends Mixins(FormRulesMixin, DepthChartTemplatesMixin, VuetifyMixin){
	mdiChevronDown = mdiChevronDown;

	// v-model form 'valid' boolean
	@Prop({ default: false }) value: boolean ;
	input(value){ this.$emit('input', value); }

	@Prop({ default: false, type: Boolean }) loading: boolean;
	@Prop({ default: null }) template: DepthChartModel | null;

	formValid = false;
	formValue = {
		name: "",
		template: null,
		autoFill: true,
	}

	get Templates(): DepthChartModel[]{
		if(this.template){
			return [
				this.template,
				...this.AvailableDepthChartTemplates
			];
		}
		return this.AvailableDepthChartTemplates;
	}

	generateName: boolean = true;
	useDefaultName(value: DepthChartModel){
		if(this.generateName){
			this.formValue.name = `${new Date().getFullYear()} | ${value.name}`;
		}
	}

	submit($event: Event){
		$event.preventDefault();
		this.$emit('submit', this.formValue);
	}

	cancel(){
		this.$emit('cancel');
	}
}
